/*
 *
 * EmailNotifications constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/MerchantNotifications';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SET_ACTIVE_NAVIGATION = `${BASE_ACTION_CONSTANT}/SET_ACTIVE_NAVIGATION`;

export const GET_ALL_EMAILS = `${BASE_ACTION_CONSTANT}/GET_ALL_EMAILS`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const HANDLE_ALL_EMAILS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_ALL_EMAILS_RESPONSE`;

export const UPDATE_ALL_EMAILS_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_ALL_EMAILS_DATA`;

export const REMOVE_EMAIL = `${BASE_ACTION_CONSTANT}/REMOVE_EMAIL`;

export const HANDLE_REMOVE_EMAIL = `${BASE_ACTION_CONSTANT}/HANDLE_REMOVE_EMAIL`;

export const UPDATE_EMAIL_CHANNEL_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_EMAIL_CHANNEL_STATUS`;

export const HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE`;

export const ADD_BULK_EMAIL = `${BASE_ACTION_CONSTANT}/ADD_BULK_EMAIL`;

export const HANDLE_ADD_BULK_EMAIL_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_ADD_BULK_EMAIL_RESPONSE`;

export const UPDATE_CUSTOMER_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_CUSTOMER_NOTIFICATIONS_STATUS`;

export const HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS`;

export const SET_ERROR_IN_ADDING_RECIPIENT = `${BASE_ACTION_CONSTANT}/SET_ERROR_IN_ADDING_RECIPIENT`;

export const GET_CUSTOMER_REFUND_NOTIFICATIONS = `${BASE_ACTION_CONSTANT}/GET_CUSTOMER_REFUND_NOTIFICATIONS`;

export const UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS`;

export const HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const EMAIL = 'EMAIL';

export const SMS = 'SMS';

export const REFUND_EMAILS = 'rfEm';

export const DELETED = 'DELETED';
export const UNVERIFIED = 'UNVERIFIED';
export const VERIFIED = 'VERIFIED';

export const EMAIL_LIST_CATEGORY_SHORTCODE = {
  trEm: 'trEm',
  rfEm: 'rfEm',
  disEm: 'disEm',
  stEm: 'stEm',
  rskEm: 'rskEm',
  pgSrUp: 'pgSrUp',
  pgDr: 'pgDr',
};

export const EMAIL_LIST = {
  trEm: {
    title: 'Transaction Emails',
    description:
      'Get notified about payment confirmation and daily transaction report details.',
  },
  rfEm: {
    title: 'Refund Emails',
    description:
      'Get notified on the different stages of refunds such as Initiated, Processed, Cancelled, and Delayed.',
  },
  disEm: {
    title: 'Dispute Emails',
    description:
      'Get notified when your customers or the issuing banks raise any disputes.',
  },
  stEm: {
    title: 'Settlement Emails',
    description:
      'Get notified when settlements are initiated for your account.',
  },
  rskEm: {
    title: 'Risk Emails',
    description: 'Get notified if any risk transactions are identified.',
  },
  pgSrUp: {
    title: 'Service Alerts',
    description:
      'Get notified when Cashfree or Partner Bank services are down and once they are back up.',
  },
  pgDr: {
    title: 'Daily Transaction Report',
    description:
      'Get notified about the total number of transactions and amount received daily.',
  },
};

export const IMPORT_EMAIL_LIST = {
  trEm: {
    title: 'Transaction Emails',
    description:
      'Get notified about payment confirmation and daily transaction report details.',
  },
  rfEm: {
    title: 'Refund Emails',
    description:
      'Get notified on the different stages of refunds such as Initiated, Processed, Cancelled, and Delayed.',
  },
  disEm: {
    title: 'Dispute Emails',
    description:
      'Get notified when your customers or the issuing banks raise any disputes.',
  },
  imstEm: {
    title: 'Settlement Emails',
    description:
      'Get notified when settlements are initiated for your account.',
  },
  imtvEm: {
    title: 'Payment Verification Emails',
    description:
      'Get notified when payment verification is processed and completed for your account.',
  },
  rskEm: {
    title: 'Risk Emails',
    description: 'Get notified if any risk transactions are identified.',
  },
  pgSrUp: {
    title: 'Service Alerts',
    description:
      'Get notified when Cashfree or Partner Bank services are down and once they are back up.',
  },
  pgDr: {
    title: 'Daily Transaction Report',
    description:
      'Get notified about the total number of transactions and amount received daily.',
  },
};

export const EMAIL_CHANNELS = [
  { key: 'TRANSACTIONS', displayText: 'Transactions', value: 'trEm' },
  {
    key: 'RISK_TRANSACTIONS',
    displayText: 'Risk Transactions',
    value: 'rskEm',
  },
  { key: 'REFUNDS', displayText: 'Refunds', value: 'rfEm' },
  { key: 'DISPUTES', displayText: 'Disputes', value: 'disEm' },
  { key: 'SETTLEMENTS', displayText: 'Settlements', value: 'stEm' },
  { key: 'SERVICE_ALERTS', displayText: 'Service Alerts', value: 'pgSrUp' },
  {
    key: 'DAILY_TRANSACTION_REPORTS',
    displayText: 'Daily Transaction Reports',
    value: 'pgDr',
  },
];

export const EMAIL_CHANNELS_FOR_IMPORT_MERCHANTS = [
  { key: 'TRANSACTIONS', displayText: 'Transactions', value: 'trEm' },
  {
    key: 'RISK_TRANSACTIONS',
    displayText: 'Risk Transactions',
    value: 'rskEm',
  },
  {
    key: 'PAYMENT_VERIFICATION',
    displayText: 'Payment Verifications',
    value: 'imtvEm',
  },
  { key: 'REFUNDS', displayText: 'Refunds', value: 'rfEm' },
  { key: 'DISPUTES', displayText: 'Disputes', value: 'disEm' },
  { key: 'SETTLEMENTS', displayText: 'Settlements', value: 'imstEm' },
  { key: 'SERVICE_ALERTS', displayText: 'Service Alerts', value: 'pgSrUp' },
  {
    key: 'DAILY_TRANSACTION_REPORTS',
    displayText: 'Daily Transaction Reports',
    value: 'pgDr',
  },
];

export const GET_ALL_EMAILS_URL = {
  url: '/common/email-channels',
  method: 'GET',
};

export const REMOVE_EMAIL_URL = {
  url: '/common/email-channel/$email$',
  method: 'DELETE',
};

export const UPDATE_EMAIL_CHANNEL_STATUS_URL = {
  url: '/common/email-channel/channel-status',
  method: 'PUT',
};

export const ADD_BULK_EMAIL_URL = {
  url: '/common/email-channel/bulk',
  method: 'POST',
};

export const UPDATE_EMAIL_URL = {
  url: '/common/email-channel/status',
  method: 'POST',
};

export const GET_CUSTOMER_NOTIFICATIONS_URL = {
  url: '/pg/customer-notification',
  method: 'GET',
};

export const UPDATE_CUSTOMER_NOTIFICATIONS_STATUS_URL = {
  url: '/pg/customer-notification',
  method: 'POST',
};

export const GET_REFUND_NOTIFICATIONS_URL = {
  url: '/pg/notification-config',
  method: 'GET',
};

export const UPDATE_REFUND_NOTIFICATIONS_STATUS_URL = {
  url: '/pg/notification-config',
  method: 'POST',
};

export const CUSTOMER_NOTIFICATIONS_DATA = [
  {
    key: 'notifyPayment',
    title: 'Payment Confirmation',
    description: 'Notify your customers when successful payments are received.',
  },
  {
    key: 'REFUND_SUCCESS',
    title: 'Refund Processed',
    description: 'Notify your customers when a refund is processed.',
  },
  {
    key: 'REFUND_CANCELLED',
    title: 'Refund Delayed/Cancelled',
    description: 'Notify your cusotomer when a refund is delayed or cancelled.',
  },
];

export const HEADINGS = [
  {
    key: 'type',
    displayName: 'Type',
    width: 4,
  },
  {
    key: 'email',
    displayName: 'Email Notification',
    width: 0.1,
  },
  {
    key: 'sms',
    displayName: 'SMS Notification',
    width: 0.1,
  },
];

export const NOTIFICATION_TYPE_MAPPER = {
  REFUND_INITIATED: 'notifyRefundProcessed',
  REFUND_SUCCESS: 'notifyRefundProcessed',
  REFUND_CANCELLED: 'notifyRefundCancelled',
  REFUND_DELAYED: 'notifyRefundCancelled',
};

export const REFUND_PARAMS = [
  { type: 'REFUND_SUCCESS', channel: SMS },
  { type: 'REFUND_SUCCESS', channel: EMAIL },
  { type: 'REFUND_CANCELLED', channel: SMS },
  { type: 'REFUND_CANCELLED', channel: EMAIL },
];

export const REFUND_EQUIVALENT_TYPE = {
  REFUND_SUCCESS: 'REFUND_INITIATED',
  REFUND_CANCELLED: 'REFUND_DELAYED',
};
